module.exports = __webpack_public_path__ + "img/23.dc2fa6c5.png";